import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-26878971"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "sub-title"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "button-container"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "button",
  onclick: "if(mini_dialog.windowstate==1){ mini_dialog.maxwindow()}"
}, "在线咨询")], -1));
const _hoisted_6 = {
  class: "example"
};
const _hoisted_7 = {
  class: "example-desc"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "link"
};
const _hoisted_10 = {
  class: "link-container"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ws_title"
}, "相关推荐", -1));
const _hoisted_12 = {
  class: "link-list"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "link-img-container"
};
const _hoisted_15 = ["src"];
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import serviceData from '@/data/service';
import ChatUs from '@/components/chat-us';
export default /*#__PURE__*/_defineComponent({
  __name: 'detail',
  setup(__props) {
    const router = useRouter();
    const $route = useRoute();
    const id = $route.params.id;
    const currentData = ref({});
    const linkData = ref([]);
    const keys = Object.keys(serviceData);
    // 防止id被篡改导致页面数据出错
    if (!keys.includes(id)) {
      router.replace('/service');
    } else {
      currentData.value = serviceData[id];
      for (let i = 0; i < 3; i++) {
        //计算出底部跳转的id
        const linkIndex = (parseInt(id) + i + 1) % keys.length;
        linkData.value.push(Object.assign({
          id: linkIndex
        }, serviceData[linkIndex]));
      }
    }
    const toLink = path => {
      router.push(path);
    };
    const visible = ref(false);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h3", _hoisted_3, _toDisplayString(currentData.value.title), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(currentData.value.price), 1), _hoisted_5])]), _createElementVNode("section", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(currentData.value.desc), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentData.value.imgUrls, item => {
        return _openBlock(), _createElementBlock("img", {
          class: "example-img",
          key: item,
          src: item,
          alt: ""
        }, null, 8, _hoisted_8);
      }), 128))]), _createElementVNode("section", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linkData.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "link-item",
          key: item.title,
          onClick: $event => toLink(`/service/${item.id}`)
        }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
          src: item.homeImg,
          alt: ""
        }, null, 8, _hoisted_15)]), _createElementVNode("h3", null, _toDisplayString(item.title), 1)], 8, _hoisted_13);
      }), 128))])])]), _createVNode(_unref(ChatUs), {
        visible: visible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => visible.value = $event)
      }, null, 8, ["visible"])], 64);
    };
  }
});